import { createCompoundComponent } from '@lounge-fe/ui-kit/src/utilities/createCompoundComponent'

import { Collection as RootCollection } from './Collection'
import { Filters } from './Filters'
import { Products } from './Products'
import { Title } from './Title'

export const Collection = createCompoundComponent(RootCollection, {
  Filters,
  Products,
  Title,
})
export * from './CollectionPage'
